import PropTypes from "prop-types";
import React, { Component } from "react";
import { Grid, Box, CircularProgress, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { withTranslation } from "react-i18next";
import HeaderInfo from "../../waybee-ui/HeaderInfo/HeaderInfo";
import Group from "../../waybee-ui/Group";
import BackButton from "../../components/BackButton";
import StudentService from "../../services/StudentService";

const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px 0;
  border-bottom: 1px solid #ececec;

  &:last-child {
    border-bottom: none;
  }
`;

const FieldLabel = styled(Typography)`
  && {
    width: 220px;
    max-width: 40%;
    color: #828282;
    font-size: 15px;
    font-weight: 500;
  }
`;

const FieldValue = styled(Typography)`
  && {
    flex: 1;
    color: #1c1f74;
    font-size: 16px;
    font-weight: 500;
  }
`;

function displayValue(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return value;
}

class StudentCustomMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: null,
      menu: null,
      loading: true,
      notFound: false
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (
      prevProps.match.params.studentId !== match.params.studentId ||
      prevProps.match.params.menuKey !== match.params.menuKey
    ) {
      this.load();
    }
  }

  load = async () => {
    const { match } = this.props;
    const { studentId, menuKey } = match.params;
    this.setState({ loading: true, notFound: false });
    try {
      const [student, menus] = await Promise.all([
        StudentService.getStudentById(studentId),
        StudentService.getCustomMenus(studentId)
      ]);
      const menu = (menus || []).find(m => m.key === menuKey) || null;
      this.setState({
        student,
        menu,
        loading: false,
        notFound: !menu
      });
    } catch (e) {
      console.error(e);
      this.setState({ loading: false, notFound: true });
    }
  };

  renderField = field => (
    <FieldRow key={field.key}>
      <FieldLabel>{field.label}</FieldLabel>
      <FieldValue>{displayValue(field.value)}</FieldValue>
    </FieldRow>
  );

  render() {
    const { student, menu, loading, notFound } = this.state;
    const { match, t } = this.props;
    const { studentId } = match.params;

    if (loading || !student) {
      return (
        <Box p={6} textAlign="center">
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        <BackButton to={`/student/${studentId}`} />
        <Grid item xs={12}>
          <Group>
            <Box mb={2}>
              <HeaderInfo
                name={student.name}
                info={t("student.raInfo", { ra: student.ra })}
                photo={student.photo}
              />
            </Box>
            <Box px={1} pb={2}>
              <Typography
                variant="h2"
                style={{ marginBottom: 16, color: "#1C1F74" }}
              >
                {menu ? menu.label : t("student.menu.custom")}
              </Typography>
              {notFound && (
                <Typography style={{ color: "#828282" }}>
                  {t("student.custom.empty")}
                </Typography>
              )}
              {!notFound &&
                (menu.fields || []).map(field => this.renderField(field))}
            </Box>
          </Group>
        </Grid>
      </Grid>
    );
  }
}

StudentCustomMenu.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      studentId: PropTypes.string,
      menuKey: PropTypes.string
    })
  }).isRequired,
  t: PropTypes.func.isRequired
};

export default withRouter(withTranslation()(StudentCustomMenu));
